import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getTherapiesByActivePortal() {
    return fetchQuery("GetTherapiesByActivePortal");
}